module.exports = __webpack_public_path__ + "static/media/temp.bc221928.png";